module.exports = __webpack_public_path__ + "img/build-spalling-rebar.e4d2eda1.jpg";